module.exports = {"setting":{"addBtn":"","breadcrumb":"Setting","header":{"edit":"Setting"},"itemAddedMessage":"","itemDeletedMessage":"","itemModalDeleteConfirmMessage":"","itemModifiedMessage":"The setting page has been changed successfully.","listDeletedMessage":"","listModalDeleteConfirmMessage":"","name":"Setting","searchBar":""}}


//////////////////
// WEBPACK FOOTER
// ./helpers/setting/lang/admin-en.json
// module id = c/p1
// module chunks = 18